class ProductFiltersController {
  constructor (Localization) {
    'ngInject'
    this.displayFilter = false
    const freeProductsOnly = Localization.getLocalizedAppConfig().freeProductsOnly
    const filters = ['all']
    if (!freeProductsOnly) {
      filters.push('paid', 'free')
    }
    filters.push('pack')
    this.filters = filters
  }

  handleChangeFilter (filter) {
    this.filter = filter
  }
}

export default ProductFiltersController



// WEBPACK FOOTER //
// ./src/app/pages/vehicle/catalog/components/product-filters/product-filters.controller.js